import cloneDeep from 'lodash/cloneDeep';
import { config as confFunc } from 'env_def';
import { ActionStore, mailBoxOfDefault, mailBoxOfOthers, mailBoxOfRdFlag, mailBoxOfSent, mailBoxOfTask, mailBoxOfDefer, mailComposeDataTable, methodMap, mailBoxOfDraft, mailBoxOfUnread, mailUnfinishedMailTable, mailBoxOfStar, mailBoxOfCustomerUnFollow, mailBoxOfUnFollow, mailBoxOfSpam, mailBoxOfAd, } from './mail_action_store_model';
import { FLOLDER, } from '@/api/logical/mail';
import { api } from '@/api/api';
import { MailAbstractHandler } from './mail_abs_handler';
import { apis } from '@/config';
import { util, traverseTreeBFS, folderId2TransMap, splitFolderStartContactId } from '@/api/util';
import corpMailUtils from './corp_mail_utils';
import { host } from '@/urlConfig/url_common';
import { getIn18Text } from '@/api/utils';
import { QuoteParser } from '@mail/read-reply-quote';
const nonceStr = '2726c7f26cyincangshousuo';
export class MailModelHandler {
    constructor(actions, subActions) {
        this.transfer = (item, config) => {
            var _a, _b, _c, _d;
            const tagName = item.tagName.toLowerCase();
            const isReadOnlyMail = config && config.get('scene') === 'readMailReadOnly';
            const { attributes } = item;
            let isAtBlock = false;
            if (attributes && attributes.length > 0) {
                isAtBlock = Array.from(attributes).some(v => {
                    const fromPC = v.name === 'data-mce-contact' && v.value === 'true';
                    const fromMobile = v.name === 'class' && v.value === 'divNeteaseSiriusATContact';
                    return fromPC || fromMobile;
                });
                const hasPraise = item.getAttribute('data-praise');
                if (isAtBlock && hasPraise !== 'true') {
                    return this.handleAtBlock(item, config);
                }
            }
            if (item && item.className && typeof item.className === 'string' && item.className.includes('mce-lx-var')) {
                item.classList.remove('mce-lx-var');
                item.classList.remove('varSpan');
                item.removeAttribute('contenteditable');
            }
            const isCorpMail = this.systemApi.getIsCorpMailMode();
            if (attributes && attributes.length > 0) {
                for (let i = 0; i < attributes.length; ++i) {
                    const attrItem = attributes.item(i);
                    if (attrItem && attrItem.name.startsWith('on')) {
                        attrItem.value = 'void(0);';
                    }
                    if (isCorpMail && attrItem && attrItem.name === 'style' && attrItem.value) {
                        attrItem.value = attrItem.value.replaceAll(/background\s*:\s*u_r_l/g, 'background:url');
                    }
                }
            }
            if (tagName.toLocaleLowerCase() === 'img') {
                const isTpMail = config && !!config.get('isTpMail');
                if (isReadOnlyMail && !isTpMail) {
                    return this.handleReadOnlyMailImageTag(item);
                }
                return this.handleImageTag(item, config);
            }
            if (tagName.toLocaleLowerCase() === 'iframe') {
                try {
                    item.setAttribute('sandbox', '');
                }
                catch (e) {
                    console.error('[transIframeSandBox]', e);
                }
            }
            if (tagName === 'script' && item.attributes.getNamedItem('nofilter') && !item.getAttribute('nonce')) {
                item.setAttribute('nonce', nonceStr);
            }
            if (tagName === 'script' && !item.attributes.getNamedItem('nofilter') && (!config || !config.get('noFilterScript'))) {
                return {
                    op: 'remove',
                };
            }
            if (item.id === 'lingxi-signature-block') {
                return this.handleSignatureTag(item, config);
            }
            if ((_a = config === null || config === void 0 ? void 0 : config.get('scene')) === null || _a === void 0 ? void 0 : _a.includes('readMail')) {
                if (tagName === 'body' && !item.className.includes('bodyMarked')) {
                    let scriptStr = `
        <script nofilter version=3 nonce="${nonceStr}">
        document.addEventListener('DOMContentLoaded', function(){
          var bqs = document.querySelectorAll('.foldEle');
          const parentWindow = window.top;

          function addOnClickFn(element) {
            element.onclick = function(e) { foldAction(e); }
          }
          for(var i=0;i <bqs.length; ++i){
            var currEl = bqs[i];
            addOnClickFn(currEl);
          }

          function foldAction(ev) {
            var currentTarget = ev.currentTarget;
            var nextElementSibling = currentTarget.nextElementSibling;
            if (!nextElementSibling) {
              return;
            }
            var className = nextElementSibling.className;
            if (className.indexOf('marked')===-1) {
              return;
            }
            if (className.indexOf('hid')!==-1) {
              var str = parentWindow  && parentWindow.__getIn18Text ? parentWindow.__getIn18Text('YINCANGYINYONGNEIRONG') : '${getIn18Text('YINCANGYINYONGNEIRONG')}'
              currentTarget.lastChild.nodeValue = str;
              nextElementSibling.className = className.replace('hid', '');
              nextElementSibling.style.display = 'block';
              localStorage.setItem('quoteShow', 'true');
            } else {
              var str = parentWindow  && parentWindow.__getIn18Text ? parentWindow.__getIn18Text('XIANSHIYINYONGNEIRONG') : '${getIn18Text('XIANSHIYINYONGNEIRONG')}'
              currentTarget.lastChild.nodeValue = str;
              nextElementSibling.className += ' hid';
              nextElementSibling.style.display = 'none';
              localStorage.setItem('quoteShow', 'false');
            }
          };
        });
          </script>
        `;
                    scriptStr += this.handlePraiseScript();
                    const tmpDoc = new DOMParser().parseFromString(scriptStr, 'text/html');
                    if ((_c = (_b = tmpDoc === null || tmpDoc === void 0 ? void 0 : tmpDoc.head) === null || _b === void 0 ? void 0 : _b.childNodes) === null || _c === void 0 ? void 0 : _c.length) {
                        tmpDoc.head.childNodes.forEach(child => {
                            item.appendChild(child);
                        });
                    }
                    item.className += ' bodyMarked';
                }
                if (tagName === 'div' && item.className.includes('marked')) {
                    config.set('marked', true);
                    const quoteExpand = localStorage.getItem('quoteShow') === 'true';
                    if (!quoteExpand) {
                        item.className += ' hid';
                        item.style.display = 'none';
                    }
                    else {
                        item.className = item.className.replace('hid', '');
                        item.style.display = '';
                    }
                    const prev = item.previousElementSibling;
                    if (prev === null || prev === void 0 ? void 0 : prev.className.includes('foldEle')) {
                        if ((_d = prev === null || prev === void 0 ? void 0 : prev.lastChild) === null || _d === void 0 ? void 0 : _d.nodeValue) {
                            prev.lastChild.nodeValue = quoteExpand ? getIn18Text('YINCANGYINYONGNEIRONG') : getIn18Text('XIANSHIYINYONGNEIRONG');
                        }
                    }
                }
            }
            if (['divNeteaseSiriusCloudAttach', 'divNeteaseBigAttach'].includes(item.id)) {
                return this.handleCloudAttachmentReplace(item, config);
            }
            if (['divNeteaseSiriusPraise'].includes(item.className) && !isReadOnlyMail) {
                return this.handlePraiseReplace(item, config);
            }
            if (['divNeteaseSiriusTask'].includes(item.className) && !isReadOnlyMail) {
                const readMail = config ? ['readMailFromNet', 'readMailFromDb'].includes(config.get('scene')) : false;
                let replaceEle = null;
                replaceEle = this.htmlApi.parseHtml(item.outerHTML).body.childNodes[0];
                if (readMail) {
                    replaceEle.style.display = 'none';
                }
                else if (!readMail) {
                    const hideEle = replaceEle.getElementsByClassName('divNeteaseSiriusHidden');
                    if (hideEle && hideEle.length > 0) {
                        for (let i = 0; i < hideEle.length; i++) {
                            const onEle = hideEle[i];
                            onEle.style.display = 'none';
                        }
                    }
                    replaceEle.className = 'divNeteaseSiriusTask-write';
                    replaceEle.style.display = 'block';
                }
                return {
                    op: 'replace',
                    el: replaceEle,
                };
            }
            if (typeof item.className === 'string' && item.className.indexOf('divNeteaseSiriusHidden') !== -1) {
                return {
                    el: item,
                    op: 'remove',
                };
            }
            if (['qiyesu-im-notice-more-text'].includes(item.className)) {
                let replaceEle = null;
                replaceEle = this.htmlApi.parseHtml(item.outerHTML).body.childNodes[0];
                replaceEle.innerHTML = '更多未读请前往消息列表查看';
                return {
                    op: 'replace',
                    el: replaceEle,
                };
            }
            if (['qiyesu-im-notice-more-btn'].includes(item.className)) {
                let replaceEle = null;
                replaceEle = this.htmlApi.parseHtml(item.outerHTML).body.childNodes[0];
                replaceEle.innerHTML = '点击前往消息列表';
                return {
                    op: 'replace',
                    el: replaceEle,
                };
            }
            return {
                op: 'none',
            };
        };
        this.simpleKeysInEntry = [
            'folder',
            'memo',
            'mark',
            'readStatus',
            'preferred',
            'praiseId',
            'eTeamType',
            'tid',
            'deferTime',
            'sentMailId',
            'tr_org_ec_id',
        ];
        this.numberKeysInEntry = ['rcptCount', 'readCount', 'innerCount', 'innerRead', 'wmReply'];
        this.booleanKeysInEntry = [
            'replayed',
            'forwarded',
            'directForwarded',
            'top',
            'isScheduleSend',
            'requestReadReceipt',
            'isDefer',
            'deferNotice',
            'popRead',
            'rcptFailed',
            'rcptSucceed',
            'system',
            'linkAttached',
            'suspiciousSpam',
            'mTrack',
        ];
        this.spStringKeyInEntry = ['title', 'brief', 'tid'];
        this.actions = actions;
        this.subActions = subActions;
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.impl = api.getDataTransApi();
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.eventApi = api.getEventApi();
        this.loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
        this.pushApi = api.requireLogicalApi(apis.pushApiImpl);
        this.htmlApi = api.requireLogicalApi(apis.htmlApi);
        this.mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
        this.dbApi = api.getNewDBApi();
        this.fileApi = api.getFileApi();
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
    }
    compare(origin, current) {
        const originS = MailModelHandler.buildMailEntryModelString(origin);
        const currentS = MailModelHandler.buildMailEntryModelString(current);
        return originS.localeCompare(currentS);
    }
    merge(a, b) {
        const { _account } = a;
        const user = this.systemApi.getCurrentUser(_account);
        if (!a) {
            return b;
        }
        if (!b) {
            return a;
        }
        if (b.receiver) {
            a.receiver = b.receiver;
        }
        a.entry.title = b.entry.title;
        if (b.entry.content && b.entry.content.content) {
            a.entry.content.content = b.entry.content.content;
        }
        if (b.aliasSender && b.aliasSender.id) {
            a.aliasSender = b.aliasSender;
        }
        if (b.entry.priority) {
            a.entry.priority = b.entry.priority;
        }
        if (b.entry.suspiciousSpam) {
            a.entry.suspiciousSpam = b.entry.suspiciousSpam;
        }
        a.scheduleDate = b.scheduleDate;
        a.scheduleDateTimeZone = b.scheduleDateTimeZone;
        a.isEncryptedMail = b.isEncryptedMail;
        a.setEncrypt = b.setEncrypt;
        if (b.entry.encpwd) {
            a.entry.encpwd = b.entry.encpwd;
        }
        a.savePassword = b.savePassword;
        a.senderReceivers = b.senderReceivers;
        a.requestReadReceipt = b.requestReadReceipt;
        a.isOneRcpt = b.isOneRcpt;
        if (a.resend || b.resend) {
            a._id = undefined;
        }
        a.handleTime = b.handleTime;
        a._account = b._account || (user === null || user === void 0 ? void 0 : user.id);
        b.draftVersionId && (a.draftVersionId = b.draftVersionId);
        return a;
    }
    hash(a) {
        const str = MailModelHandler.buildMailEntryModelString(a);
        return this.systemApi.md5(str);
    }
    static buildMailEntryModelString(a) {
        var _a, _b, _c, _d;
        const doc = this.htmlApi.parseHtml(((_b = (_a = a === null || a === void 0 ? void 0 : a.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content) || '');
        const receiverStr = a.receiver ? a.receiver.map((it, idx) => String(idx) + '_' + it.mailMemberType + it.contactItem.contactItemVal).join('') : '';
        return (+receiverStr +
            (((_c = a.entry) === null || _c === void 0 ? void 0 : _c.title) || '') +
            (this.htmlApi.generateElStr(doc) || '') +
            (((_d = a.entry) === null || _d === void 0 ? void 0 : _d.folder) || '0'));
    }
    unFreezeObject(obj) {
        try {
            return cloneDeep(obj);
        }
        catch (error) {
            return Object.assign({}, obj);
        }
    }
    getEntryFromCacheCid(cid, _account) {
        let targetAccount = '';
        if (_account) {
            targetAccount = _account || '';
        }
        const accountId = cid.split('&seq&')[0];
        if (accountId) {
            targetAccount = accountId;
        }
        const targetActions = this.mailApi.getActions({ actions: this.actions, subActions: this.subActions, _account: targetAccount }).val;
        if (targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailEntryCache[cid]) {
            return this.unFreezeObject(targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailEntryCache[cid]);
        }
        return undefined;
    }
    syncAndUpdateLocalContentInMemory(_content) {
        if (_content && _content.cid) {
            let item = this.getEntryFromCacheCid(_content.cid, _content._account);
            if (item) {
                item = this.merge(item, _content);
                return item;
            }
        }
        return undefined;
    }
    async syncAndUpdateLocalContent(_content, noMerge) {
        const content = this.unFreezeObject(_content);
        if (!content.cid) {
            content.cid = MailModelHandler.seq.nextOne(_content === null || _content === void 0 ? void 0 : _content._account);
            await this.saveEntryToStore(content);
            return this.loadEntryFromStore(content.cid);
        }
        let item = this.getEntryFromCacheCid(content.cid);
        if (item && !noMerge) {
            item = this.merge(item, content);
        }
        else {
            item = this.unFreezeObject(content);
        }
        if (!item) {
            item = await this.loadEntryFromStore(content.cid);
        }
        await this.saveEntryToStore(item, content.cid);
        return item;
    }
    updateLocalContent(_content, noMerge) {
        const { _account } = _content;
        const content = this.unFreezeObject(_content);
        if (!content.cid) {
            content.cid = MailModelHandler.seq.nextOne(_account);
            this.saveEntryToStore(content).then();
            return content;
        }
        let item = this.getEntryFromCacheCid(content.cid, _account);
        if (item && !noMerge) {
            item = this.merge(item, content);
        }
        else {
            item = this.unFreezeObject(content);
        }
        this.saveEntryToStore(item, content.cid).then();
        return item;
    }
    stringifyMailEntry(content) {
        if (!content) {
            return undefined;
        }
        content.createTime = new Date().getTime();
        const s = JSON.stringify(content, (_, val) => {
            if (val instanceof File) {
                return undefined;
            }
            return val;
        });
        return JSON.parse(s);
    }
    clearEntryFromStore(cid, eid, _account) {
        const targetAction = this.mailApi.getActions({ actions: this.actions, subActions: this.subActions, _account }).val;
        if (!targetAction) {
        }
        targetAction === null || targetAction === void 0 ? true : delete targetAction.mailEntryCache[cid];
        const mid = MailModelHandler.mailPrefix + cid;
        const mailIds = targetAction.writingMailIds;
        mailIds.delete(mid);
        for (let i = 0; i < 3; ++i) {
            try {
                const lockName = MailAbstractHandler.COMMON_ATTACHMENT_LOCK_NAME + '-' + eid + '-' + i;
                const uploadLock = this.storeApi.getLock(lockName, 20 * 60 * 1000 + 10, true);
                if (uploadLock) {
                    uploadLock.destroyLock();
                }
            }
            catch (e) {
                console.log('[mail] error unlock', e);
            }
        }
    }
    saveInitModelToStore(content) {
        if (content.id) {
            this.storeApi.put(MailModelHandler.mailInitModelPrefix + content.id, JSON.stringify(content)).then();
        }
    }
    delInitModelToStore(content) {
        if (content.id) {
            this.storeApi.del(MailModelHandler.mailInitModelPrefix + content.id).then();
        }
    }
    loadInitModelToStore(mid) {
        if (mid && !util.extractPathFromCid(mid)) {
            const sync = this.storeApi.getSync(MailModelHandler.mailInitModelPrefix + mid);
            return sync && sync.suc && sync.data ? JSON.parse(sync.data) : undefined;
        }
        return undefined;
    }
    async saveEntryToStoreNomerge(item, cid) {
        if (!cid && !item.cid) {
            cid = MailModelHandler.seq.nextOne(item === null || item === void 0 ? void 0 : item._account);
        }
        else if (!cid && item.cid) {
            cid = item.cid;
        }
        if (!item.cid) {
            item.cid = cid;
        }
        if (!cid) {
            return;
        }
        if (!item.id) {
            item.id = cid + '-tmp';
            item.entry && (item.entry.id = item.id);
        }
        const targetActions = this.mailApi.getActions({ actions: this.actions, subActions: this.subActions, _account: item === null || item === void 0 ? void 0 : item._account }).val;
        if (targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailEntryCache) {
            targetActions.mailEntryCache[cid] = item;
        }
        console.log('[mail] save to cache item saveEntryToStoreNomerge', item);
        const storeObj = this.stringifyMailEntry(item);
        if (storeObj) {
            const inElectron = this.systemApi.isElectron() && window.electronLib;
            if (inElectron) {
                let _dbAccount = '';
                const fromEmail = cid.split('&seq&')[0];
                fromEmail && (_dbAccount = fromEmail);
                if (_dbAccount) {
                    await this.dbApi.put(Object.assign(Object.assign({}, mailComposeDataTable), { _dbAccount }), storeObj).then();
                }
                else {
                    await this.dbApi.put(mailComposeDataTable, storeObj).then();
                }
            }
            else {
                await this.dbApi.put(mailComposeDataTable, storeObj).then();
            }
            targetActions && targetActions.writingMailIds && targetActions.writingMailIds.add(String(cid));
        }
    }
    async saveEntryToStore(item, cid, attachment, _account) {
        const targetAccount = _account || (item === null || item === void 0 ? void 0 : item._account);
        if (!cid && !item.cid) {
            cid = MailModelHandler.seq.nextOne(targetAccount);
        }
        else if (!cid && item.cid) {
            cid = item.cid;
        }
        if (!item.cid) {
            item.cid = cid;
        }
        if (!cid) {
            return;
        }
        if (!item.id) {
            item.id = cid + '-tmp';
            item.entry && (item.entry.id = item.id);
        }
        let data = this.getEntryFromCacheCid(cid, item._account);
        if (!data) {
            data = await this.loadEntryFromStore(cid, item._account);
        }
        if (!Array.isArray(item.entry.attachment)) {
            item.entry.attachment = [];
        }
        if (data && data.entry && data.entry.attachment && attachment && attachment.length > 0) {
            item = this.mergeAttachment(item, data, attachment);
        }
        const targetActions = this.mailApi.getActions({ actions: this.actions, subActions: this.subActions, _account: item === null || item === void 0 ? void 0 : item._account }).val;
        if (targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailEntryCache) {
            targetActions.mailEntryCache[cid] = item;
        }
        console.log('[mail] save to cache item saveEntryToStore', item);
        const storeObj = this.stringifyMailEntry(item);
        if (storeObj) {
            const inElectron = this.systemApi.isElectron() && window.electronLib;
            if (inElectron) {
                let _dbAccount = '';
                const fromEmail = cid.split('&seq&')[0];
                fromEmail && (_dbAccount = fromEmail);
                if (_dbAccount) {
                    await this.dbApi.put(Object.assign(Object.assign({}, mailComposeDataTable), { _dbAccount }), storeObj).then();
                }
                else {
                    await this.dbApi.put(mailComposeDataTable, storeObj).then();
                }
            }
            else {
                await this.dbApi.put(mailComposeDataTable, storeObj).then();
            }
            targetActions && targetActions.writingMailIds && targetActions.writingMailIds.add(String(cid));
        }
    }
    async mergeStoreUnfinishedMail(_content, delExpiredDraft) {
        const { _account } = _content;
        if (_account && _account !== this.systemApi.getMainAccount1().email)
            return;
        const content = this.unFreezeObject(_content);
        let item = this.getEntryFromCacheCid(_content.cid);
        if (item) {
            item = this.merge(item, content);
            await this.saveEntryToUnfinishedMail(item, delExpiredDraft === true);
        }
    }
    async saveEntryToUnfinishedMail(item, delExpiredDraft) {
        const { _account } = item;
        if (_account && _account !== this.systemApi.getMainAccount1().email)
            return;
        const storeObj = this.stringifyMailEntry(item);
        if (storeObj) {
            const inElectron = this.systemApi.isElectron() && window.electronLib;
            if (inElectron) {
                await this.dbApi.put(mailUnfinishedMailTable, storeObj);
            }
            else {
                await this.dbApi.put(mailUnfinishedMailTable, storeObj);
            }
            if (delExpiredDraft) {
                await this.delExpiredDraftVersion(item.cid);
            }
        }
    }
    async coverDraft(cid, draftId) {
        const curCidDrafts = await this.dbApi.getByEqCondition({
            dbName: 'mail_new',
            tableName: 'unfinished_mail',
            query: { cid },
        });
        await this.dbApi.deleteById({
            dbName: 'mail_new',
            tableName: 'unfinished_mail',
        }, curCidDrafts.map(item => item.draftVersionId));
        await this.dbApi.putAll(mailUnfinishedMailTable, curCidDrafts.map(item => (Object.assign(Object.assign({}, item), { draftId }))));
    }
    async delExpiredDraftVersion(cid) {
        const curCidDrafts = await this.dbApi.getByEqCondition({
            dbName: 'mail_new',
            tableName: 'unfinished_mail',
            query: { cid },
        });
        const orderedCidDrafts = util.setDataOrder({
            data: curCidDrafts,
            orderBy: [['createTime', false]],
        });
        if ((orderedCidDrafts === null || orderedCidDrafts === void 0 ? void 0 : orderedCidDrafts.length) > 3) {
            const delIds = orderedCidDrafts.splice(3).map(item => item.draftVersionId);
            if (delIds.length > 0) {
                await this.dbApi.deleteById({
                    dbName: 'mail_new',
                    tableName: 'unfinished_mail',
                }, delIds);
            }
        }
    }
    async saveEntryToStore1(item, cid) {
        if (!cid && !item.cid) {
            cid = MailModelHandler.seq.nextOne(item === null || item === void 0 ? void 0 : item._account);
        }
        else if (!cid && item.cid) {
            cid = item.cid;
        }
        if (!item.cid) {
            item.cid = cid;
        }
        if (!cid) {
            return false;
        }
        if (!item.id) {
            item.id = cid + '-tmp';
            item.entry && (item.entry.id = item.id);
        }
        await new Promise(resolve => {
            var _a;
            if (!item.entry.attachment || item.entry.attachment.length === 0) {
                resolve('');
            }
            (_a = item.entry.attachment) === null || _a === void 0 ? void 0 : _a.forEach(async (attachItem, index) => {
                var _a;
                const { attachPath } = attachItem;
                if (attachPath) {
                    const localfile = await window.electronLib.fsManage.readFile(attachPath);
                    const sep = window.electronLib.env.isMac ? '/' : '\\';
                    const file = new File([localfile], attachPath.split(sep).pop());
                    attachItem.file = file;
                }
                if (((_a = item.entry.attachment) === null || _a === void 0 ? void 0 : _a.length) === index + 1) {
                    resolve('');
                }
            });
        });
        const targetAction = this.mailApi.getActions({ actions: this.actions, subActions: this.subActions, _account: item === null || item === void 0 ? void 0 : item._account }).val;
        if (targetAction === null || targetAction === void 0 ? void 0 : targetAction.mailEntryCache) {
            targetAction.mailEntryCache[cid] = item;
        }
        console.log('[mail] save to cache item saveEntryToStore1', item);
        const storeObj = this.stringifyMailEntry(item);
        if (storeObj) {
            await this.dbApi.put(mailComposeDataTable, storeObj).then();
            this.actions.writingMailIds.add(String(cid));
        }
        return true;
    }
    mergeAttachment(item, data, attachment) {
        var _a;
        if (!data || !((_a = data.entry) === null || _a === void 0 ? void 0 : _a.attachment)) {
            return item;
        }
        const savedData = data.entry.attachment.filter(it => !!it.realId);
        const savedDataMap = new Map();
        savedData.forEach(it => {
            savedDataMap.set(it.realId || it.id, it);
        });
        attachment.forEach(att => {
            const key = att.realId || att.id;
            const saved = savedDataMap.get(key);
            if (!saved || !(saved === null || saved === void 0 ? void 0 : saved.deleted)) {
                savedDataMap.set(key, att);
            }
        });
        this.loggerApi.track('mail_merge_attahment', { savedData, attachment });
        item.entry.attachment = [...savedDataMap.values()];
        return item;
    }
    async electronloadEntryFromStore(cid, _account) {
        let _dbAccount = '';
        let element = this.getEntryFromCacheCid(cid, _account);
        if (!element) {
            let dbRes = null;
            const fromEmail = cid.split('&seq&')[0];
            fromEmail && (_dbAccount = fromEmail);
            if (_dbAccount) {
                dbRes = await this.dbApi.getById(Object.assign(Object.assign({}, mailComposeDataTable), { _dbAccount }), cid, _dbAccount);
            }
            else {
                dbRes = await this.dbApi.getById(Object.assign({}, mailComposeDataTable), cid, _dbAccount);
            }
            element = dbRes;
        }
        return Object.assign(Object.assign({}, element), { _account: (element === null || element === void 0 ? void 0 : element._account) || _dbAccount });
    }
    async loadEntryFromStore(cid, _account) {
        let targetAccount = '';
        if (_account) {
            targetAccount = _account || '';
        }
        else {
            const accountId = cid.split('&seq&')[0];
            if (accountId) {
                targetAccount = accountId;
            }
        }
        let element = this.getEntryFromCacheCid(cid, targetAccount);
        if (!element) {
            const inElectron = this.systemApi.isElectron() && window.electronLib;
            if (inElectron) {
                element = await this.electronloadEntryFromStore(cid, targetAccount);
            }
            else {
                const dbRes = await this.dbApi.getById(Object.assign({}, mailComposeDataTable), cid, targetAccount);
                element = dbRes;
            }
        }
        return element;
    }
    async loadEntryFromStore1(cid, _account) {
        var _a, _b;
        let element = this.getEntryFromCacheCid(cid, _account);
        if (!element) {
            const re = await this.dbApi.getById(mailComposeDataTable, cid, _account);
            element = re;
        }
        (_b = (_a = element === null || element === void 0 ? void 0 : element.entry) === null || _a === void 0 ? void 0 : _a.attachment) === null || _b === void 0 ? void 0 : _b.forEach((attachment) => {
            (attachment === null || attachment === void 0 ? void 0 : attachment.file) && delete attachment.file;
        });
        return element;
    }
    async initEntryFromStore() {
        const resultObjects = await this.dbApi.getByEqCondition(mailComposeDataTable);
        const now = new Date().getTime();
        const delIds = [];
        resultObjects.forEach(it => {
            var _a;
            if (it) {
                const entry = it;
                const targetActions = (_a = this.mailApi.getActions({
                    actions: this.actions,
                    subActions: this.subActions,
                    _account: entry._account,
                })) === null || _a === void 0 ? void 0 : _a.val;
                if (entry.cid && entry.createTime && entry.createTime + MailModelHandler.MAIL_ENTRY_EXPIRED_SPAN > now) {
                    targetActions.mailEntryCache[entry.cid] = entry;
                    console.log('[mail] save to cache item initEntryFromStore', entry);
                    targetActions.writingMailIds.add(String(entry.cid));
                }
                else if (entry.cid) {
                    const isEmlRecord = util.extractPathFromCid(entry.cid);
                    if (!isEmlRecord) {
                        delIds.push(entry.cid);
                    }
                }
            }
        });
        if (delIds.length > 0) {
            this.dbApi.deleteById(mailComposeDataTable, delIds).then();
        }
    }
    checkAllFailToSendMails(req, ret, search) {
        var _a;
        if (req.ids || req.id !== mailBoxOfSent.id || req.index !== 0) {
            return 0;
        }
        try {
            const targetActions = (_a = this.mailApi.getActions({
                actions: this.actions,
                subActions: this.subActions,
                _account: req._account,
            })) === null || _a === void 0 ? void 0 : _a.val;
            const { mailEntryCache } = targetActions;
            let num = 0;
            Object.keys(mailEntryCache).forEach(i => {
                const key = Number(i);
                if (Object.prototype.hasOwnProperty.apply(mailEntryCache, [key]) &&
                    mailEntryCache[key] &&
                    mailEntryCache[key].entry &&
                    mailEntryCache[key].entry.sendStatus &&
                    mailEntryCache[key].cid &&
                    mailEntryCache[key].id) {
                    if (ret) {
                        const element = this.getEntryFromCacheCid(mailEntryCache[key].cid);
                        if (element) {
                            if (!search) {
                                ret.push(element);
                            }
                            else if (targetActions.searchContentOfEntry(element, search)) {
                                ret.push(element);
                            }
                        }
                    }
                    num += 1;
                }
            });
            return num;
        }
        catch (ex) {
            console.warn('[mail] get local mail failed ', ex);
            return 0;
        }
    }
    async insertStarContactIntoMailbox(mailBox, starList) {
        if (Array.isArray(starList) && starList.length > 0) {
            mailBox.forEach(v => {
                if (v.mailBoxId === mailBoxOfStar.id) {
                    v.children = starList;
                    v.childrenCount = starList.length;
                    const unread = starList.reduce((t, v) => {
                        t += v.entry.mailBoxUnread;
                        return t;
                    }, 0);
                    v.entry.mailBoxUnread = unread;
                    v.entry.mailBoxCurrentUnread = unread;
                    v.entry.threadMailBoxUnread = unread;
                    v.entry.threadMailBoxCurrentUnread = unread;
                }
            });
        }
        console.log('[start list] mailBox', mailBox);
        return mailBox;
    }
    isValidStarFolderId(fid) {
        if (!fid) {
            return false;
        }
        const [type, id] = splitFolderStartContactId(fid);
        return type && id && ['personal', 'org'].includes(type);
    }
    async doGetStarContactQuery(folderId, _account) {
        const fid = String(folderId);
        if (!this.isValidStarFolderId(fid)) {
            return {
                id: '',
                emailList: [],
                attrValue: '',
            };
        }
        const [type, id] = splitFolderStartContactId(fid);
        const promise = type === 'personal' ? () => this.contactApi.doGetContactById(id, _account) : () => this.contactApi.doGetContactByOrgId({ orgId: id, _account });
        const contactModels = await promise();
        const emailList = contactModels.reduce((total, current) => {
            var _a;
            total.push(...(((_a = this.contactApi.transContactModel2ContactItem(current)) === null || _a === void 0 ? void 0 : _a.emailList) || []));
            return total;
        }, []);
        const attrValue = this.getStarAttrValue(id, emailList);
        console.log('doGetStarContactQuery', emailList, attrValue);
        return {
            id,
            emailList,
            attrValue,
        };
    }
    getStarAttrValue(id, emailList) {
        return this.systemApi.md5(`${id}${emailList.join('')}`, true);
    }
    async handleCommonFolderRet(_dt, starListModels, _account) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        let dt;
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        try {
            dt = _dt.filter(v => v.mailBoxType === 'customer' || (v.mailBoxType === 'sys' && v.mailBoxId));
            if (process.env.BUILD_ISLINGXI && !((_b = this.systemApi.doGetProductInfo()) === null || _b === void 0 ? void 0 : _b.navigateVersion)) {
                dt = dt.filter(v => v.mailBoxId !== mailBoxOfCustomerUnFollow.id && v.mailBoxId !== mailBoxOfUnFollow.id);
            }
            if (process.env.BUILD_ISEDM || ((_c = this.systemApi.doGetProductInfo()) === null || _c === void 0 ? void 0 : _c.navigateVersion)) {
                dt = dt.filter(v => v.mailBoxId !== mailBoxOfStar.id);
            }
            if (process.env.BUILD_ISEDM || ((_d = this.systemApi.doGetProductInfo()) === null || _d === void 0 ? void 0 : _d.navigateVersion)) {
                dt = dt.filter(v => v.mailBoxId !== mailBoxOfTask.id);
            }
            const allVirtualFolders = Object.values(FLOLDER).filter(value => typeof value === 'number' && value < 0);
            dt = dt.filter(v => {
                if (+v.mailBoxId < 0 && !allVirtualFolders.includes(+v.mailBoxId)) {
                    return false;
                }
                return true;
            });
        }
        catch (error) {
            dt = _dt;
        }
        const ret = [];
        const trans = {};
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        let baseExtraMailBoxes = [mailBoxOfRdFlag];
        if (!isCorpMail) {
            baseExtraMailBoxes = [mailBoxOfRdFlag, mailBoxOfUnread, mailBoxOfDefer];
            if (!(process.env.BUILD_ISEDM || ((_e = this.systemApi.doGetProductInfo()) === null || _e === void 0 ? void 0 : _e.navigateVersion))) {
                baseExtraMailBoxes.push(mailBoxOfTask);
            }
            if (!(process.env.BUILD_ISEDM || ((_f = this.systemApi.doGetProductInfo()) === null || _f === void 0 ? void 0 : _f.navigateVersion))) {
                baseExtraMailBoxes.push(mailBoxOfStar);
            }
            if (process.env.BUILD_ISEDM || ((_g = this.systemApi.doGetProductInfo()) === null || _g === void 0 ? void 0 : _g.navigateVersion)) {
                baseExtraMailBoxes.push(mailBoxOfCustomerUnFollow);
                baseExtraMailBoxes.push(mailBoxOfUnFollow);
            }
        }
        const systemMailBoxes = dt.filter(v => v.mailBoxType === 'sys').map(b => b.mailBoxId);
        const currentUser = this.systemApi.getCurrentUser(_account);
        const sendFolderSort = dt.findIndex(v => v.mailBoxId === mailBoxOfSent.id);
        baseExtraMailBoxes.forEach(it => {
            var _a;
            if (!systemMailBoxes.includes(it.id) && actions) {
                const { mailBoxDic } = actions;
                const currentBox = [mailBoxOfDefer.id, mailBoxOfCustomerUnFollow.id, mailBoxOfUnFollow.id].includes(it.id) && mailBoxDic && mailBoxDic[it.id] ? mailBoxDic[it.id] : null;
                let { sort } = actions.mailBoxConfs[it.id];
                if (it.id === mailBoxOfCustomerUnFollow.id) {
                    sort = sendFolderSort + 0.1;
                }
                else if (it.id === mailBoxOfUnFollow.id) {
                    sort = sendFolderSort + 0.2;
                }
                const mailBox = {
                    childrenCount: 0,
                    _account: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                    authAccountType: (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _a === void 0 ? void 0 : _a.authAccountType,
                    entry: {
                        deferCount: (currentBox === null || currentBox === void 0 ? void 0 : currentBox.deferCount) || 0,
                        mailBoxName: it.name || '',
                        mailBoxCurrentUnread: (currentBox === null || currentBox === void 0 ? void 0 : currentBox.mailBoxCurrentUnread) || 0,
                        mailBoxUnread: (currentBox === null || currentBox === void 0 ? void 0 : currentBox.mailBoxUnread) || 0,
                        mailBoxTotal: (currentBox === null || currentBox === void 0 ? void 0 : currentBox.mailBoxTotal) || 0,
                        mailBoxType: 'sys',
                        mailBoxId: it.id,
                        mailBoxParent: 0,
                        threadMailBoxTotal: (currentBox === null || currentBox === void 0 ? void 0 : currentBox.threadMailBoxTotal) || 0,
                        threadMailBoxUnread: (currentBox === null || currentBox === void 0 ? void 0 : currentBox.threadMailBoxUnread) || 0,
                        threadMailBoxCurrentUnread: (currentBox === null || currentBox === void 0 ? void 0 : currentBox.threadMailBoxCurrentUnread) || 0,
                        id: actions.mailBoxConfs[it.id].id + '',
                        sort,
                    },
                    mailBoxId: it.id,
                    children: [],
                };
                ret.push(mailBox);
                trans[it.id] = mailBox;
            }
        });
        for (const entry of dt) {
            const id = Number(entry.mailBoxId);
            trans[id] = {
                childrenCount: 0,
                _account: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                authAccountType: (_h = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _h === void 0 ? void 0 : _h.authAccountType,
                entry,
                children: [],
            };
        }
        const children = {};
        for (const item of dt) {
            const id = item.mailBoxId;
            const pid = item.pid || 0;
            const model = trans[+id];
            model.mailBoxId = id;
            const mailBoxConf = actions.mailBoxConfs[+id];
            if (mailBoxConf === null || mailBoxConf === void 0 ? void 0 : mailBoxConf.hide) {
                continue;
            }
            model.entry.mailBoxName = (mailBoxConf === null || mailBoxConf === void 0 ? void 0 : mailBoxConf.name) || model.entry.mailBoxName;
            if (model.entry.mailBoxType === 'sys') {
                if (mailBoxConf === null || mailBoxConf === void 0 ? void 0 : mailBoxConf.getUnreadNumber) {
                    const unreadNumber = mailBoxConf.getUnreadNumber(model);
                    model.entry.mailBoxUnread = unreadNumber.unread;
                    model.entry.mailBoxCurrentUnread = unreadNumber.currentUnread;
                    model.entry.threadMailBoxUnread = unreadNumber.threadUnread;
                    model.entry.threadMailBoxCurrentUnread = unreadNumber.currentThreadUnread;
                }
                if ([mailBoxOfCustomerUnFollow.id, mailBoxOfUnFollow.id].includes(+model.entry.mailBoxId) && actions.mailBoxDic && actions.mailBoxDic[model.entry.mailBoxId]) {
                    const currentBox = actions.mailBoxDic[model.entry.mailBoxId];
                    model.entry.mailBoxTotal = (currentBox === null || currentBox === void 0 ? void 0 : currentBox.mailBoxTotal) || 0;
                    model.entry.threadMailBoxTotal = (currentBox === null || currentBox === void 0 ? void 0 : currentBox.threadMailBoxTotal) || 0;
                }
                if (model.entry.mailBoxId === mailBoxOfDraft.id) {
                    model.entry.threadMailBoxTotal = model.entry.mailBoxTotal;
                }
                if (model.entry.mailBoxId === 1) {
                    ret.unshift(model);
                }
                else {
                    ret.push(model);
                }
            }
            else if (model.entry.mailBoxType === 'customer') {
                if (pid === 0) {
                    ret.push(model);
                }
                else {
                    const parent = trans[pid];
                    if (parent) {
                        parent.children.push(model);
                        parent.childrenCount += 1;
                        this.handleParentCount(trans, parent, model.entry.mailBoxCurrentUnread, model.entry.threadMailBoxCurrentUnread);
                    }
                    else {
                        let list = children[pid];
                        if (!list) {
                            list = [];
                        }
                        list.push(model);
                        children[pid] = list;
                    }
                }
            }
        }
        Object.keys(children).forEach(i => {
            if (Object.prototype.hasOwnProperty.apply(children, [i]) && children[Number(i)]) {
                children[Number(i)].forEach(it => {
                    const parent = trans[Number(i)];
                    if (parent) {
                        parent.children.push(it);
                        parent.childrenCount += 1;
                        this.handleParentCount(trans, parent, it.entry.mailBoxCurrentUnread, it.entry.threadMailBoxCurrentUnread);
                    }
                });
            }
        });
        let urFolderUnRead = 0;
        let threadUrFolderUnRead = 0;
        const ignoreFolderId = [mailBoxOfDraft.id, mailBoxOfUnread.id, mailBoxOfDefer.id, mailBoxOfStar.id, mailBoxOfSpam.id, mailBoxOfAd.id];
        ret.forEach(model => {
            if (model && model.mailBoxId && !ignoreFolderId.includes(+model.mailBoxId)) {
                urFolderUnRead += model.entry.mailBoxUnread;
                threadUrFolderUnRead += model.entry.threadMailBoxUnread;
            }
        });
        ret.forEach(model => {
            if (model && model.mailBoxId && model.mailBoxId === mailBoxOfUnread.id) {
                model.entry.mailBoxUnread = urFolderUnRead;
                model.entry.mailBoxCurrentUnread = urFolderUnRead;
                model.entry.threadMailBoxUnread = threadUrFolderUnRead;
                model.entry.threadMailBoxCurrentUnread = threadUrFolderUnRead;
            }
        });
        const result = ret.sort((prev, next) => prev.entry.sort - next.entry.sort);
        let resultWithStarContacts = result;
        if (!(process.env.BUILD_ISEDM || ((_j = this.systemApi.doGetProductInfo()) === null || _j === void 0 ? void 0 : _j.navigateVersion))) {
            resultWithStarContacts = await this.insertStarContactIntoMailbox(result, starListModels);
        }
        traverseTreeBFS(resultWithStarContacts, (node, deep) => {
            if (node && (node === null || node === void 0 ? void 0 : node.entry)) {
                node.entry._deep = deep;
                if (node.entry.mailBoxId != null && folderId2TransMap[node.entry.mailBoxId]) {
                    const folderTransName = folderId2TransMap[node.entry.mailBoxId];
                    node.entry.mailBoxName = getIn18Text(folderTransName) || node.entry.mailBoxName;
                }
            }
        }, 100000);
        console.log('[star list]', resultWithStarContacts);
        return resultWithStarContacts;
    }
    handleParentCount(trans, parent, mailBoxCurrentUnread, threadMailBoxCurrentUnread) {
        let c = true;
        do {
            if (Array.isArray(parent.children) && parent.children.length > 1) {
                parent.children.sort((prev, next) => prev.entry.sort - next.entry.sort);
            }
            parent.entry.mailBoxUnread += mailBoxCurrentUnread;
            parent.entry.threadMailBoxUnread += threadMailBoxCurrentUnread;
            const { pid } = parent.entry;
            const parentId = pid === 0 ? mailBoxOfOthers.id : pid;
            if (parentId) {
                parent = trans[parentId];
                c = !!parent;
            }
            else {
                c = false;
            }
        } while (c);
    }
    init() {
        MailModelHandler.seq = this.storeApi.getSeqHelper('mail-content');
    }
    buildInitContent(param) {
        let con = '';
        if (param.originContent && param.originContent.length > 0) {
            if (param.originContent.indexOf('\n') < 0) {
                con = '<p>' + param.originContent + '</p><p></p>';
            }
            else {
                const strings = param.originContent.split('\n');
                strings.forEach(it => {
                    con += '<p>' + it + '</p>';
                });
            }
        }
        return con;
    }
    buildTpMailUrl(url, additionalParam) {
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser) {
            return MailAbstractHandler.comNotExist;
        }
        let req = {
            sid: currentUser.sessionId,
        };
        if ((additionalParam === null || additionalParam === void 0 ? void 0 : additionalParam.sid) === '') {
            additionalParam === null || additionalParam === void 0 ? true : delete additionalParam.sid;
            additionalParam === null || additionalParam === void 0 ? true : delete additionalParam.session;
        }
        if (additionalParam) {
            req = Object.assign(req, additionalParam);
        }
        const conf = {
            noAddingHost: false,
        };
        return this.impl.buildUrl(this.systemApi.getUrl(url), req, conf);
    }
    buildUrl(payloads) {
        const { key, additionalParam, urlPath, noSid, _account } = payloads;
        const splitReq = false;
        const currentUser = this.systemApi.getCurrentUser(_account);
        if (!currentUser) {
            return MailAbstractHandler.comNotExist;
        }
        const isCorpMailMode = this.systemApi.getIsCorpMailMode();
        if (isCorpMailMode) {
            return corpMailUtils.buildUrlForCorpMail(key, additionalParam);
        }
        let req = {
            func: methodMap[key],
            sid: currentUser.sessionId,
        };
        if (noSid) {
            delete req.sid;
        }
        if ((additionalParam === null || additionalParam === void 0 ? void 0 : additionalParam.sid) === '') {
            additionalParam === null || additionalParam === void 0 ? true : delete additionalParam.sid;
            additionalParam === null || additionalParam === void 0 ? true : delete additionalParam.session;
        }
        console.log('[mail] build api for ' + req.func + '->' + req.sid, currentUser);
        if (additionalParam) {
            req = Object.assign(req, additionalParam);
        }
        const conf = {
            noAddingHost: key === 'downloadTmpAttachment',
        };
        const generateUrl = this.impl.buildUrl(this.systemApi.getUrl(urlPath || 'mailOperation', '', splitReq, _account), req, conf);
        return generateUrl;
    }
    handleReadOnlyMailImageTag(item) {
        const originSrc = item.getAttribute('src');
        if (originSrc && originSrc.length > 2) {
            const host = originSrc.startsWith('http') || originSrc.startsWith('data:') || !this.systemApi.isElectron() ? '' : confFunc('host');
            item.setAttribute('src', host + originSrc);
            return {
                op: 'none',
            };
        }
        return {
            op: 'remove',
        };
    }
    handleImageTag(item, config) {
        var _a, _b, _c;
        const readMail = config ? config.get('readMail') === 'true' : false;
        const isTpMail = config && !!config.get('isTpMail');
        const _account = config && config.get('_account');
        const colleagueAccId = config && config.get('colleagueAccId');
        const subEmail = config && config.get('subEmail');
        const attachments = config && config.get('attachments');
        const relatedEmailRefId = config && config.get('relatedEmailRefId');
        const relatedEmailType = config && config.get('relatedEmailType');
        const subAccount = this.storeApi.getSubAccountList() || [];
        const isSubAccount = subAccount.some((it) => it.email === _account);
        const imageConf = readMail && config ? config.get('imageConf') : null;
        const FALLBACK_SRC_KEY = 'data-origin-src';
        let needHandleSiriusImage = this.systemApi.isElectron() && readMail && imageConf;
        const originSrc = item.getAttribute('src');
        const oldOriginSrc = item.getAttribute('wirte-origin-src');
        if (oldOriginSrc && originSrc) {
            const pattern = /composeId=(\w+)/;
            const oldMatch = oldOriginSrc.match(pattern);
            const newMatch = originSrc.match(pattern);
            const oldComposeId = oldMatch && oldMatch[1];
            const newComposeId = newMatch && newMatch[1];
            if (oldComposeId !== newComposeId) {
                item.removeAttribute('wirte-origin-src');
            }
        }
        if (item.getAttribute('wirte-origin-src') === null)
            item.setAttribute('wirte-origin-src', originSrc || '');
        const originFallbackSrc = item.getAttribute(FALLBACK_SRC_KEY);
        const isSiriusImage = originSrc && originSrc.startsWith('sirius');
        let imageConfKey = '';
        if (originSrc && originSrc.length > 2) {
            let originUrl = needHandleSiriusImage && isSiriusImage ? originFallbackSrc : originSrc;
            if (originUrl && originUrl.length > 2) {
                let url = originUrl;
                url = this.htmlApi.decodeHtml(url);
                const isDecryptedMailImage = url.includes('decryptMessagePart');
                if (isDecryptedMailImage) {
                    needHandleSiriusImage = false;
                }
                const queryMap = this.htmlApi.parseUrlQuery(url);
                const { attachId } = queryMap;
                const attachSize = Array.isArray(attachments) && ((_a = attachments.find((it) => it.id == attachId)) === null || _a === void 0 ? void 0 : _a.fileSize);
                queryMap.attachSize = attachSize || 0;
                if (queryMap.mid && queryMap.Part) {
                    imageConfKey = `${queryMap.mid}-${queryMap.Part}`;
                }
                try {
                    if (url.includes('/api/pub/edm/read')) {
                        const regExp = '/api/pub/edm/read(.)+';
                        const match = url.match(regExp);
                        if (match && match[0]) {
                            item.setAttribute('src', decodeURIComponent(host + '/trace') + match[0]);
                            return {
                                op: 'none',
                            };
                        }
                    }
                }
                catch (e) {
                    console.log(e);
                }
                try {
                    if (url.includes('/api/pub/url/mail/scan')) {
                        const regExp = '/api/pub/url/mail/scan(.)+';
                        const match = url.match(regExp);
                        if (match && match[0]) {
                            item.setAttribute('src', decodeURIComponent(host + '/mail-enhance') + match[0]);
                            return {
                                op: 'none',
                            };
                        }
                    }
                }
                catch (e) {
                    console.log(e);
                }
                let func;
                if (isDecryptedMailImage) {
                    func = 'getDecryptedMailPart';
                }
                else if (url.includes('/biz/email/getMessageData') || url.includes('colleagueGetMessageData')) {
                    func = 'getTpMailPart';
                }
                else if (url.indexOf('mbox:getMessageData') >= 0 || url.indexOf('mbox%3AgetMessageData') >= 0) {
                    func = 'getMailPart';
                }
                else if (url.indexOf('mbox:getComposeData') >= 0 || url.indexOf('mbox%3AgetComposeData') >= 0) {
                    func = 'downloadTmpAttachment';
                }
                else if (url.includes('/coremail') && (url.includes('func=user:proxyGet') || url.includes('user%3AproxyGet'))) {
                    item.setAttribute('src', decodeURIComponent(queryMap.url || ''));
                }
                else if (url.includes('/corp-mail')) {
                    if (url.includes('mail/message/data')) {
                        func = 'getMailPart';
                        if (queryMap.mid) {
                            queryMap.mid = decodeURIComponent(queryMap.mid);
                        }
                    }
                }
                if (func) {
                    delete queryMap.func;
                    delete queryMap.sid;
                    delete queryMap.p;
                    if (isSubAccount) {
                        if (!process.env.BUILD_ISELECTRON) {
                            queryMap._token = ((_b = this.mailConfApi.accountTokens.find(token => token.account === _account)) === null || _b === void 0 ? void 0 : _b.token) || '';
                        }
                        else {
                            queryMap._session = this.systemApi.getSessionNameOfSubAccount(_account);
                        }
                    }
                    else {
                        const curNode = this.systemApi.getCurrentNode();
                        queryMap._ms = curNode || 'hz';
                    }
                    let replaceValue = '';
                    if (func === 'getTpMailPart') {
                        queryMap._appName = this.systemApi.getAppName();
                        if (colleagueAccId && subEmail) {
                            queryMap.colleagueAccId = colleagueAccId;
                            queryMap.subEmail = subEmail;
                            replaceValue = this.buildTpMailUrl('getTpMailPartNew', queryMap);
                        }
                        else {
                            if (relatedEmailRefId && relatedEmailType) {
                                const type = relatedEmailType === 'CUSTOMER' ? 'conversation' : 'hint';
                                queryMap.refId = relatedEmailRefId;
                                queryMap.type = type;
                            }
                            replaceValue = this.buildTpMailUrl('getTpMailPart', queryMap);
                        }
                    }
                    else if (isSubAccount && !process.env.BUILD_ISELECTRON) {
                        replaceValue = this.buildUrl({ key: func, urlPath: 'mailProxyOperation', additionalParam: queryMap, _account });
                    }
                    else {
                        replaceValue = this.buildUrl({ key: func, additionalParam: queryMap, _account });
                    }
                    if (!process.env.BUILD_ISELECTRON && replaceValue && !replaceValue.startsWith('http')) {
                        replaceValue = (((_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.origin) || '') + replaceValue;
                    }
                    if (!(config && config.get('host'))) {
                        item.setAttribute('src', replaceValue);
                    }
                    if (!readMail) {
                        const wirteOriginSrc = item.getAttribute('wirte-origin-src');
                        if (wirteOriginSrc) {
                            item.removeAttribute('wirte-origin-src');
                            originUrl = wirteOriginSrc;
                        }
                        const newSrc = originUrl.replace(/^.*(js6\/s.+$)/gi, (_, p1) => decodeURIComponent('/' + p1));
                        console.log('[mail] src test ', newSrc);
                        item.setAttribute('src', newSrc);
                        if (queryMap && queryMap.composeId && queryMap.attachId && config) {
                            config.set('img-' + queryMap.attachId, newSrc);
                        }
                    }
                    console.log('[mail] handle image result，src ,value=', item.outerHTML, replaceValue, readMail);
                }
                if (needHandleSiriusImage) {
                    const handledSrc = item.getAttribute('src');
                    const currentConf = imageConf && imageConf.get(imageConfKey);
                    if (currentConf) {
                        item.setAttribute('src', `sirius://sirius.file/${encodeURIComponent(currentConf.filePath)}`);
                        item.setAttribute(FALLBACK_SRC_KEY, handledSrc || '');
                        item.setAttribute('fid', currentConf.fid);
                    }
                }
            }
            return {
                op: 'none',
            };
        }
        return {
            op: 'remove',
        };
    }
    handleSignatureTag(item, config) {
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (isCorpMail) {
            corpMailUtils.handleCorpSignatureEl(item);
        }
        const readMail = config ? config.get('readMail') === 'true' : false;
        let itemHtmlStr = item.outerHTML;
        let replaceEle = null;
        if (readMail && item.tagName.toLowerCase() === 'a') {
            itemHtmlStr = itemHtmlStr.replace(/^\<a/, '<div').replace(/a\>$/, 'div>');
            replaceEle = this.htmlApi.parseHtml(itemHtmlStr).body.childNodes[0];
            replaceEle.setAttribute('data-tagchange', '1');
        }
        else if (!readMail && item.hasAttribute('data-tagchange')) {
            const copyItem = this.htmlApi.parseHtml(itemHtmlStr).body.querySelector('#lingxi-signature-block');
            if (!copyItem) {
                return {
                    op: 'none',
                };
            }
            const childrenStr = copyItem.innerHTML;
            copyItem.innerHTML = '';
            let copyItemHtmlStr = copyItem.outerHTML;
            copyItemHtmlStr = copyItemHtmlStr.replace(/^\<div/, '<a').replace(/div\>$/, 'a>');
            replaceEle = this.htmlApi.parseHtml(copyItemHtmlStr).body.childNodes[0];
            replaceEle.innerHTML = childrenStr;
            replaceEle.removeAttribute('data-tagchange');
            item.removeAttribute('data-tagchange');
        }
        else {
            return {
                op: 'none',
            };
        }
        const { attributes } = item;
        if (attributes && attributes.length > 0) {
            for (let i = 0; i < attributes.length; ++i) {
                const attrItem = attributes.item(i);
                if (replaceEle.hasAttribute('data-tagchange') && replaceEle[attrItem.name] === undefined) {
                    replaceEle.setAttribute(`data-${attrItem.name}`, attrItem.value);
                    replaceEle.removeAttribute(attrItem.name);
                }
                else if (!replaceEle.hasAttribute('data-tagchange') && attrItem.name.indexOf('data-') !== -1) {
                    replaceEle.setAttribute(attrItem.name.replace('data-', ''), attrItem.value);
                    replaceEle.removeAttribute(attrItem.name);
                }
            }
        }
        return {
            op: 'replace',
            el: replaceEle,
        };
    }
    handleAtBlock(item, config) {
        const readMail = config ? config.get('readMail') === 'true' : false;
        if (readMail) {
            const currentUser = this.systemApi.getCurrentUser(config ? config.get('readMail') : '');
            const atTarget = item.getAttribute('data-mce-contact-id') || item.getAttribute('mail-address');
            if (!currentUser || !atTarget) {
                return {
                    op: 'none',
                };
            }
            if (currentUser.id === atTarget || (currentUser.prop && Array.isArray(currentUser.prop.accountAlias) && currentUser.prop.accountAlias.includes(atTarget))) {
                const style = {
                    display: 'inline-block',
                    background: '#386EE7',
                    'border-radius': '3px',
                    padding: '2px 4px',
                    color: '#fff',
                    outline: 'none',
                    cursor: 'pointer',
                };
                const styleStr = Object.keys(style).reduce((total, current) => {
                    total += `${current}: ${style[current]};`;
                    return total;
                }, '');
                item.setAttribute('style', styleStr);
                return {
                    el: item,
                    op: 'replace',
                };
            }
        }
        return {
            op: 'none',
        };
    }
    async handleMailContentReplace(model, scene, writeType, isTpMail) {
        var _a, _b, _c, _d, _e;
        const { _account } = model;
        const con = model.entry.content;
        const attachments = model.entry.attachment;
        const currentUser = this.systemApi.getCurrentUser(_account);
        const isSubAccount = this.mailConfApi.isSubAccount(_account);
        if (!currentUser) {
            this.eventApi.sendSimpleSysEvent('logout');
            throw new Error('why not login' + scene);
        }
        if (con.isHtml) {
            const conf = new Map([
                ['mailModel', model],
                ['isTpMail', isTpMail],
                ['_account', _account],
                ['attachments', attachments],
            ]);
            if (!isTpMail) {
                await this.addImageConf(conf, scene, _account);
            }
            if (isTpMail) {
                if ((_a = model === null || model === void 0 ? void 0 : model.tpMailInfo) === null || _a === void 0 ? void 0 : _a.colleagueAccId) {
                    conf.set('colleagueAccId', model.tpMailInfo.colleagueAccId);
                }
                if ((_b = model === null || model === void 0 ? void 0 : model.tpMailInfo) === null || _b === void 0 ? void 0 : _b.belongEmail) {
                    conf.set('subEmail', model.tpMailInfo.belongEmail);
                }
                if ((_c = model === null || model === void 0 ? void 0 : model.tpMailInfo) === null || _c === void 0 ? void 0 : _c.refId) {
                    conf.set('relatedEmailRefId', model.tpMailInfo.refId);
                }
                if ((_d = model === null || model === void 0 ? void 0 : model.tpMailInfo) === null || _d === void 0 ? void 0 : _d.type) {
                    conf.set('relatedEmailType', model.tpMailInfo.type);
                }
            }
            con._account = _account;
            con.nonfold = model.nonfold;
            con.content = this.getTransferHtml(con, scene, true, conf);
            const cloudAttachments = [];
            const urlSet = new Set();
            conf.forEach((val, key) => {
                const atta = val;
                if (key.startsWith('atta-') && val && atta.fileUrl && !urlSet.has(atta.fileUrl) && !(writeType && ['reply', 'replyAll'].includes(writeType))) {
                    cloudAttachments.push(val);
                    urlSet.add(atta.fileUrl);
                }
            });
            if (model.entry.attachment) {
                if (isSubAccount && !process.env.BUILD_ISELECTRON) {
                    const _token = ((_e = this.mailConfApi.accountTokens.find(token => token.account === _account)) === null || _e === void 0 ? void 0 : _e.token) || '';
                    model.entry.attachment = model.entry.attachment.map((v) => {
                        let { fileUrl } = v;
                        if (fileUrl && fileUrl.includes('&_token=')) {
                            fileUrl = fileUrl.replace(/&_token=[^&]*/, `&_token=${_token}`);
                        }
                        else {
                            fileUrl = `${fileUrl}&_token=${_token}`;
                        }
                        return Object.assign(Object.assign({}, v), { fileUrl });
                    });
                }
                if (cloudAttachments && cloudAttachments.length > 0) {
                    model.entry.attachment.push(...cloudAttachments);
                }
            }
        }
        else if (!con.isHtml) {
            con.content = con.content.replace(/\r?\n|(\\n)/g, '<br/>');
        }
    }
    isOldVerCloudAttachment(href) {
        return ['http://fs.qiye.163.com/', 'https://fs.qiye.163.com/'].some(v => href.startsWith(v));
    }
    handleCloudAttachmentReplace(item, config) {
        var _a, _b;
        const readMail = config ? config.get('readMail') === 'true' : false;
        if (['divNeteaseSiriusCloudAttach'].includes(item.id)) {
            if (!readMail) {
                return {
                    el: item,
                    op: 'remove',
                };
            }
            if (config && config.get('scene') === 'writeLetterSinceExist') {
                const attachments = (_b = (_a = config === null || config === void 0 ? void 0 : config.get('mailModel')) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.attachment;
                const cloudAtt = (attachments || []).find((att) => att.type === 'netfolder');
                if (cloudAtt) {
                    return {
                        el: item,
                        op: 'remove',
                    };
                }
            }
            const booleans = this.handleCloudAttachment(item, config);
            if (booleans.length > 0 && !booleans.some(cur => !cur)) {
                return {
                    el: item,
                    op: 'remove',
                };
            }
            return {
                el: item,
                op: 'replace',
            };
        }
        return {
            op: 'none',
        };
    }
    handlePraiseScript() {
        return `<script>
    document.addEventListener("DOMContentLoaded", () => {
      // targetWrapName 需要裁剪元素
      // expandedName 展开按钮元素
      // foldName 折叠按钮元素
      // listenToggleWrapName 展开 折叠的wrap元素
      // lineMaxNumber 最大行数
      function listenLineText(targetWrapName, expandedName, foldName, listenToggleWrapName, lineMaxNumber) {
        // 表扬对象wrap
        const praiseTargetWarpEl = document.querySelector(targetWrapName);
        if (!praiseTargetWarpEl) return;
        const cssStyle = praiseTargetWarpEl.style.cssText;
        // 表扬对象toggle
        const praiseExpandedEl = document.querySelector(expandedName);
        if (!praiseExpandedEl) return;
        const praiseFoldEl = document.querySelector(foldName);
        if (!praiseFoldEl) return;
        const clipperStyle = 'display:-webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp:'+lineMaxNumber+';overflow: hidden;';
        if (praiseTargetWarpEl.offsetHeight > 21 * lineMaxNumber) {
          praiseTargetWarpEl.style.cssText += clipperStyle;
          praiseExpandedEl.style.display = "block";
        }
        const listenToggleWrapEl = document.querySelector(listenToggleWrapName);
        if (!listenToggleWrapEl) return;
        listenToggleWrapEl.addEventListener("click", function(e) {
          const target = e.target || src.srcElement;
          if (expandedName.includes(target.className.baseVal)) {
            praiseTargetWarpEl.style.cssText = cssStyle;
            praiseExpandedEl.style.display = "none";
            praiseFoldEl.style.display = "block";
          } else if (foldName.includes(target.className.baseVal)) {
            praiseTargetWarpEl.style.cssText += clipperStyle;
            praiseExpandedEl.style.display = "block";
            praiseFoldEl.style.display = "none";
          }
        });
      }
      // 监听表扬对象
      listenLineText(".praise-winners-wrap", ".praise-winner-expanded", ".praise-winner-fold", ".praise-winner-toggle", 3);
      // 监听颁奖词
      listenLineText(".praise-words-wrap", ".praise-words-expanded", ".praise-words-fold", ".praise-words-toggle", 5);
      const praiseMedalEl = document.querySelector('.praise-medal')
      if (praiseMedalEl) {
        const medalData = JSON.parse(praiseMedalEl.getAttribute("data-medal-source") || "null");
        // gif图会被浏览器缓存最后一帧，加个时间戳保证正常渲染
        praiseMedalEl.style.background = "url("+ medalData.gifImageUrl +"&"+ new Date().getTime() +") no-repeat center/contain"
      }
    });
  </script>`;
    }
    handlePraiseReplace(item, config) {
        var _a, _b;
        const readMail = config ? config.get('readMail') === 'true' : false;
        const currentUser = this.systemApi.getCurrentUser(config ? config.get('_account') : '');
        if (readMail) {
            const dataSource = JSON.parse(item.getAttribute('data-source') || 'null');
            if (dataSource) {
                const temp = (_a = dataSource.winners) === null || _a === void 0 ? void 0 : _a.map(winner => winner.email);
                const index = temp.indexOf((currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || '');
                if (index > -1) {
                    const curData = dataSource.winners.splice(index, 1)[0];
                    dataSource.winners.unshift(curData);
                }
                const replaceEl = document.createElement('div');
                const contentEl = ` <div
        class="divNeteaseSiriusPraise"
        contenteditable="false"
        style="position: relative;margin: 0 auto 16px;min-width: 460px;max-width: 588px;border-radius: 12px;user-select:none;
        background: url('https://cowork-storage.nos-jd.163yun.com/reward%2F2022%2F02%2F22%2F84aa392741404c44ba78b8c3af3f33e4?Signature=N08sbMa89Yy0YI6KQmwYfdNeyN07wzqoC29DNM2%2FaKg%3D&Expires=32503651199&NOSAccessKeyId=0cd796d04a3a45dba2ef94a2f2a0c218');
        background-size: cover;"
      >
        <img
          src="https://cowork-storage.nos-jd.163yun.com/reward%2F2022%2F02%2F22%2F75343b0ac49c4d148734f4700c278357?Signature=LKJYQxt7UPA0QC5jgw8maLqt0PadZWu7Ov%2Fip3Jwgbk%3D&Expires=32503651199&NOSAccessKeyId=0cd796d04a3a45dba2ef94a2f2a0c218"
          alt=""
          style="position: absolute;z-index:1;top: 0;left: 0;width: 20%;max-width: 100px;height: auto;border-radius: 12px 0 0 0;"
        />
        <img
          src="https://cowork-storage.nos-jd.163yun.com/reward%2F2022%2F02%2F22%2Fb3652394296144fdaf632074c05637b5?Signature=rd6EgCXTY%2FryJ%2FpkPPAj1vfe0dm3ZronMSk12bh0O8A%3D&Expires=32503651199&NOSAccessKeyId=0cd796d04a3a45dba2ef94a2f2a0c218"
          alt=""
          style="position: absolute;z-index:1;top: 0;right: 0;width: 13%;max-width: 70px;height: auto;border-radius: 0 12px 0 0;"
        />
        <img
          src="https://cowork-storage.nos-jd.163yun.com/reward%2F2022%2F02%2F22%2F91201de5ac9b4fe6b59fb52a46068c42?Signature=%2FUdU6kOAp4%2BCrHj3wFI0q7LCkqpY3y6NAb92UuRL9PA%3D&Expires=32503651199&NOSAccessKeyId=0cd796d04a3a45dba2ef94a2f2a0c218"
          alt=""
          style="position: absolute;z-index:1;bottom: 0;left: 0;width: 30%;max-width: 90px;height: auto;border-radius: 0 0 0 12px;"
        />
        <img
          src="https://cowork-storage.nos-jd.163yun.com/reward%2F2022%2F02%2F22%2Fd83514ae0cd44303b5bffd6a730622e7?Signature=kwxXPFqPcoX4jJT1O0g4g%2BISJp3RMF6We8vQsM2Kt74%3D&Expires=32503651199&NOSAccessKeyId=0cd796d04a3a45dba2ef94a2f2a0c218"
          alt=""
          style="position: absolute;z-index:1;bottom: 0;right: 0;width: 29%;max-width: 120px;height: auto;border-radius: 0 0 12px 0;"
        />
        <div style="position: relative;padding-bottom: 30px;z-index: 2;overflow: hidden;">
          <div class="praise-medal" data-medal-source='${JSON.stringify(dataSource.medal)}' data-hasOwner="${index > -1}" style="width: 176px;height: 150px;margin: 12px auto 25px;background: url(${dataSource.medal.gifImageUrl}) no-repeat center/contain;cursor: pointer;"></div>
          <div style="display: flex;font-size: 14px;color: #51555C;margin: 25px 20px 0">
            <p style="width: 70px;text-align-last: justify;color: rgba(38, 42, 51, 0.5);margin: 0;">表扬对象：</p>
            <div class="praise-winners-wrap" style="color: #262A33;flex: 1;line-height: 21px;">
            ${(_b = dataSource.winners) === null || _b === void 0 ? void 0 : _b.map((winner, index) => `<span data-praise="true" data-mce-contact-id="${winner.email}" data-mce-contact="true" data-mce-contact-type="EMAIL" data-hubble-event-id="pcMail_click_readMail_praiseLetter​_contactDetails​"
            style="display: inline-block;cursor: pointer;${winner.email === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) ? 'font-weight:bold' : ''}">
              ${winner.name}${index === (dataSource === null || dataSource === void 0 ? void 0 : dataSource.winners.length) - 1 ? '' : '、'} 
            </span>`).join('')}
            </div>
          </div>
          <div class="praise-winner-toggle">
            <svg style="display: none;margin: 8px auto;cursor: pointer;" class="praise-winner-expanded" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 5.5L8 10.5L13 5.5" stroke="#7D8085" stroke-width="1.2" stroke-linejoin="round" />
            </svg>
            <svg style="display: none;margin: 8px auto;cursor: pointer;" class="praise-winner-fold" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 10.5L8 5.5L3 10.5" stroke="#7D8085" stroke-width="1.2" stroke-linejoin="round" />
            </svg>
          </div>
          <div style="display: flex;font-size: 14px;margin: 12px 20px 0">
            <p style="width: 70px;text-align-last: justify;color: rgba(38, 42, 51, 0.5);margin: 0;">颁奖词：</p>
            <pre class="praise-words-wrap" style="flex: 1;white-space: pre-wrap;line-height: 21px;color: #51555C;margin: 0;">${dataSource.presentationWords}</pre>
          </div>
          <div class="praise-words-toggle">
            <svg style="display: none;margin: 8px auto;cursor: pointer;" class="praise-words-expanded" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 5.5L8 10.5L13 5.5" stroke="#7D8085" stroke-width="1.2" stroke-linejoin="round" />
            </svg>
            <svg style="display: none;margin: 8px auto;cursor: pointer;" class="praise-words-fold" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 10.5L8 5.5L3 10.5" stroke="#7D8085" stroke-width="1.2" stroke-linejoin="round" />
            </svg>
          </div>
          <div style="display: flex;font-size: 14px;margin: 12px 20px 0">
            <p style="width: 70px;text-align-last: justify;color: rgba(38, 42, 51, 0.5);margin: 0;">颁奖人：</p>
            <span style="line-height: 150%;color: #262A33;">${dataSource.presenter}</span>
          </div>
        </div>
      </div>`;
                replaceEl.innerHTML = contentEl;
                return {
                    op: 'replace',
                    el: replaceEl,
                };
            }
            return {
                op: 'none',
            };
        }
        return {
            op: 'none',
        };
    }
    handleCloudAttachment(attachmentParentEl, conf) {
        if (!attachmentParentEl || attachmentParentEl.children.length === 0) {
            return [];
        }
        const result = [];
        const attachmentEl = attachmentParentEl.children;
        if (attachmentEl && attachmentEl.length > 0) {
            Array.from(attachmentEl)
                .slice(1)
                .forEach(item => {
                const el = item.querySelector('.divNeteaseSiriusCloudAttachItem') || item.querySelector('.divNeteaseBigAttachItem');
                if (el) {
                    const fileName = el.getAttribute('file-name') || '';
                    const url = el.getAttribute('href') || '';
                    if (fileName && url && !this.isOldVerCloudAttachment(url)) {
                        const attachmentURL = new URL(url);
                        const fileMime = el.getAttribute('file-mime') || '';
                        const fileType = el.getAttribute('file-type') || '';
                        const size = el.getAttribute('file-size');
                        const fileSize = size ? +size : 0;
                        const fid = el.getAttribute('file-id') || el.getAttribute('fid') || '';
                        const identity = attachmentURL.searchParams.get('identity') || fid;
                        const realId = this.generateRndId();
                        const id = el.getAttribute('id') || realId;
                        const expired = Number(el.getAttribute('expired')) || 0;
                        const file = {
                            fileMime,
                            fileName,
                            fileType,
                            fileSize,
                            realId,
                            type: 'netfolder',
                            contentId: undefined,
                            id: id,
                            inlined: false,
                            contentLocation: undefined,
                            fileUrl: url,
                            fileOriginUrl: url,
                            deleted: false,
                            ready: true,
                            filePreviewUrl: url,
                            fileSourceType: 1,
                            fileSourceKey: this.systemApi.md5(url),
                            cloudAttachment: true,
                            cloudIdentity: identity,
                            expired,
                        };
                        this.fileApi.registerTmpFile(file);
                        conf === null || conf === void 0 ? void 0 : conf.set('atta-' + id, file);
                        item.setAttribute('style', 'display:none');
                        result.push(true);
                    }
                    else {
                        result.push(false);
                    }
                }
                else {
                    result.push(false);
                }
            });
        }
        return result;
    }
    generateRndId() {
        return (Date.now() % 1000000) * 1000 + Math.floor(Math.random() * 1000);
    }
    getTransferHtml(con, scene, needHtml = true, conf) {
        const readMailScenes = ['readMailReadOnly', 'readMailFromNet', 'readMailFromDb', 'sign', 'writeLetterSinceNon', 'writeLetterSinceExist'];
        const inReadMailPage = ['readMailReadOnly', 'readMailFromNet', 'readMailFromDb'].includes(scene);
        const document = this.htmlApi.parseHtml(con.content);
        const config = conf || new Map();
        const readMailWay = readMailScenes.includes(scene);
        const host = readMailWay ? '' : this.mailConfApi.getWebMailHost(true);
        let hasFoldEle = Boolean(document.getElementsByClassName('foldEle').length > 0 || con.nonfold);
        config.set('host', host);
        config.set('readMail', String(!!readMailWay));
        config.set('scene', scene);
        config.set('_account', con._account);
        let shtml;
        if (needHtml && document.documentElement.tagName.toLowerCase() !== 'html') {
            const element = document.createElement('html');
            element.append('body');
            const rootElement = element.children.item(0);
            if (rootElement) {
                rootElement.append(document.documentElement);
                if (!hasFoldEle && inReadMailPage) {
                    hasFoldEle = this.parseQuote(element);
                }
                config.set('hasFoldEle', hasFoldEle);
                shtml = this.htmlApi.transferHtml(element, this.transfer, config);
            }
            else {
                throw new Error('html error');
            }
        }
        else if (needHtml || document.documentElement.tagName.toLowerCase() !== 'html') {
            if (!hasFoldEle && inReadMailPage) {
                hasFoldEle = this.parseQuote(document.documentElement);
            }
            config.set('hasFoldEle', hasFoldEle);
            shtml = this.htmlApi.transferHtml(document, this.transfer, config);
        }
        else {
            if (!hasFoldEle && inReadMailPage) {
                hasFoldEle = this.parseQuote(document.documentElement);
            }
            config.set('hasFoldEle', hasFoldEle);
            shtml = this.htmlApi.transferHtml(document.body, this.transfer, config);
        }
        con.content = shtml;
        return shtml;
    }
    delImgFailedUpload(con) {
        try {
            const document = this.htmlApi.parseHtml(con);
            const errWrapDom = document.querySelectorAll('.paste-img-reload:not(.hide)');
            if (errWrapDom && errWrapDom.length) {
                errWrapDom.forEach(i => {
                    var _a;
                    let errWrapParentDom = null;
                    errWrapParentDom = i.closest('.upload-img-wrapper');
                    if (!errWrapParentDom) {
                        errWrapParentDom = i.closest('.paste-img-wrapper');
                    }
                    (_a = errWrapParentDom === null || errWrapParentDom === void 0 ? void 0 : errWrapParentDom.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(errWrapParentDom);
                });
                return document.documentElement.innerHTML;
            }
            return con;
        }
        catch (err) {
            return con;
        }
    }
    async addImageConf(config, scene, _account) {
        var _a;
        const mail = config.get('mailModel');
        const isReadMail = ['readMailReadOnly', 'readMailFromNet', 'readMailFromDb'].includes(scene);
        if (!isReadMail) {
            return config;
        }
        const imageConf = new Map();
        if (this.systemApi.isElectron() && mail && Array.isArray((_a = mail.entry) === null || _a === void 0 ? void 0 : _a.attachment)) {
            const fileOriginUrls = mail.entry.attachment.filter(v => v.inlined && v.fileType && util.isImage(v.fileType) && v.fileOriginUrl).map(v => v.fileOriginUrl || '');
            if (fileOriginUrls.length > 0) {
                const fileRecords = (await this.dbApi.getByIndexIds({
                    dbName: 'fileop',
                    tableName: 'file',
                }, 'fileOriginUrl', fileOriginUrls, _account)).filter(v => !!v);
                if (Array.isArray(fileRecords) && fileRecords.length > 0) {
                    fileRecords.forEach(({ filePath, fileOriginUrl, fid }) => {
                        const fileExist = filePath && window.electronLib.fsManage.isExist(filePath);
                        if (fileExist && fileOriginUrl) {
                            const query = this.htmlApi.parseUrlQuery(fileOriginUrl);
                            if (query.mid && query.Part) {
                                const key = `${query.mid}-${query.Part}`;
                                imageConf.set(key, { filePath, fid: fid });
                            }
                        }
                    });
                }
            }
        }
        if (imageConf.size > 0) {
            config.set('imageConf', imageConf);
        }
        return config;
    }
    parseQuote(elem) {
        const quoteParser = new QuoteParser(null, {
            containForward: true,
            returnQuoteHead: true,
        });
        const quoteRet = quoteParser.exec(elem);
        if (!((quoteRet === null || quoteRet === void 0 ? void 0 : quoteRet.quotes) && quoteRet.quotes.length > 0)) {
            return false;
        }
        const quoteExpand = localStorage.getItem('quoteShow') === 'true';
        const quoteStartNode = quoteRet.quotes[0];
        const doc = elem.ownerDocument;
        const foldIcon = '<svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#386EE7" style="margin-right: 6px;">' +
            '<path d="M2.5 2.5A.5.5 0 013 2h10a.5.5 0 01.5.5v11a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5v-11z" stroke="#386EE7"></path>' +
            '<path d="M5 5h6M5 8h3.5" stroke="#386EE7" stroke-linecap="round"></path>' +
            '</svg>';
        const foldElem = doc.createElement('div');
        foldElem.className = 'foldEle';
        foldElem.style.cssText = 'font-size:14px;line-height:16px;color:#386EE7;margin:16px 0;cursor:pointer;display:flex;';
        foldElem.innerHTML = foldIcon + (quoteExpand ? getIn18Text('YINCANGYINYONGNEIRONG') : getIn18Text('XIANSHIYINYONGNEIRONG'));
        const markedElem = doc.createElement('div');
        markedElem.className = 'marked';
        if (quoteStartNode.parentNode) {
            quoteStartNode.parentNode.insertBefore(foldElem, quoteStartNode);
            quoteStartNode.parentNode.insertBefore(markedElem, quoteStartNode);
            const frag = doc.createDocumentFragment();
            for (let idx = 0; idx < quoteRet.quotes.length; idx++) {
                const node = quoteRet.quotes[idx];
                if (node) {
                    frag.appendChild(node);
                }
            }
            markedElem.appendChild(frag);
        }
        return true;
    }
    isEntryContentEmpty(ret) {
        return !ret || !ret.entry.content || !ret.entry.content.content || ret.entry.content.content.length === 0;
    }
    checkAttachmentUrl(result) {
        if (!result.entry.attachment || result.entry.attachment.length === 0) {
            return false;
        }
        return result.entry.attachment.some((i) => {
            if (!i.fileUrl) {
                return false;
            }
            return i.fileUrl.indexOf('js6') !== -1;
        });
    }
    saveMailBoxContentToAction(_, mailBoxEntry, _account) {
        var _a;
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (actions) {
            actions.lastMailBoxUpdateTime[ActionStore.keyMailSyncTime] = new Date().getTime();
            mailBoxEntry.forEach(item => {
                if (item.mailBoxId && actions.mailBoxDic) {
                    if (![mailBoxOfStar.id, mailBoxOfUnread.id].includes(item.mailBoxId)) {
                        actions.mailBoxDic[+item.mailBoxId] = Object.assign({}, item);
                    }
                }
            });
        }
        else {
            console.error('[saveMailBoxContentToAction] actions is null', _account);
        }
    }
    notifyFolderCountChange(noCache, _account) {
        return new Promise(resolve => {
            setTimeout(() => {
                this.calFolderUnread(_account);
                this.eventApi.sendSysEvent({
                    eventName: 'mailChanged',
                    eventStrData: 'refreshFolder',
                    eventData: {
                        noCache,
                    },
                    _account,
                });
                resolve(true);
            }, 100);
        });
    }
    calFolderUnread(_account) {
        var _a;
        const isThreadMode = this.mailConfApi.getMailMergeSettings() === 'true';
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const { mailBoxDic } = actions;
        if (!mailBoxDic) {
            return;
        }
        let unread = 0;
        Object.keys(mailBoxDic).forEach(key => {
            if (mailBoxDic && Object.prototype.hasOwnProperty.apply(mailBoxDic, [key]) && mailBoxDic[Number(key)]) {
                const item = mailBoxDic[Number(key)];
                const fid = Number(item.id);
                if (item && (fid === mailBoxOfDefault.id || item.mailBoxType === 'customer')) {
                    unread += isThreadMode ? item.threadMailBoxCurrentUnread : item.mailBoxCurrentUnread;
                }
            }
        });
        if (unread < 0) {
            unread = 0;
            console.error('[mail] something wrong... and the unread is less then 0: ', unread);
        }
        this.loggerApi.track('mark_mail', { stage: 'cal_folder_unread', isThreadMode, mailBoxDic, unread });
        this.updateUnreadCount(unread, _account);
    }
    updateUnreadCount(unread, _account) {
        this.pushApi.triggerNotificationInfoChange({
            action: 'new_mail_num',
            num: unread,
            content: '',
            title: '',
        }, _account);
    }
    compareMailBoxModel(cacheResult, netResult) {
        if (cacheResult && netResult) {
            if (cacheResult.length !== netResult.length) {
                return true;
            }
            const len = cacheResult.length;
            for (let i = 0; i < len; ++i) {
                const itemA = cacheResult[i];
                const itemB = netResult[i];
                if (this.compareMailBoxItem(itemA, itemB)) {
                    return true;
                }
            }
        }
        return false;
    }
    compareMailBoxItem(itemA, itemB) {
        const entryNEq = itemA.entry.mailBoxUnread !== itemB.entry.mailBoxUnread ||
            itemA.entry.mailBoxCurrentUnread !== itemB.entry.mailBoxCurrentUnread ||
            itemA.entry.mailBoxTotal !== itemB.entry.mailBoxTotal ||
            itemA.entry.mailBoxId !== itemB.entry.mailBoxId ||
            itemA.entry.sort !== itemB.entry.sort;
        if (entryNEq) {
            return true;
        }
        if (itemA.children && itemA.children.length > 0) {
            if (!itemB.children || itemB.children.length !== itemA.children.length) {
                return true;
            }
            const len = itemA.children.length;
            for (let i = 0; i < len; ++i) {
                if (this.compareMailBoxItem(itemA.children[i], itemB.children[i])) {
                    return true;
                }
            }
        }
        return false;
    }
    compareMailEntryModel(itemA, itemB) {
        const idA = itemA.isThread ? itemA.threadId : itemA.id;
        const idB = itemB.isThread ? itemB.threadId : itemB.id;
        const isIdDifferent = !!idB && idA !== idB;
        if (isIdDifferent) {
            return true;
        }
        if (itemA.isOneRcpt !== itemB.isOneRcpt) {
            return true;
        }
        if (itemA.antispamInfo !== itemB.antispamInfo) {
            return true;
        }
        if (itemA.taskId !== itemB.taskId) {
            return true;
        }
        const threadIdA = itemA.threadId;
        const threadIdB = itemB.threadId;
        const isThreadIdDifferent = !!threadIdB && threadIdA !== threadIdB;
        if (isThreadIdDifferent) {
            return true;
        }
        const isBooleanDifferent = this.booleanKeysInEntry.some(key => (itemA.entry[key] || false) !== (itemB.entry[key] || false));
        if (isBooleanDifferent) {
            return true;
        }
        const simpleKeysInEntry = itemA.isThread ? [...this.simpleKeysInEntry.slice(1)] : this.simpleKeysInEntry;
        if (itemB.entry.memo !== itemA.entry.memo) {
            return true;
        }
        const isStringInEntryDifferent = simpleKeysInEntry.some(key => itemB.entry[key] && itemA.entry[key] !== itemB.entry[key]);
        if (isStringInEntryDifferent) {
            return true;
        }
        const isNumberInEntryDifferent = this.numberKeysInEntry.some(key => itemA.entry[key] !== itemB.entry[key]);
        if (isNumberInEntryDifferent) {
            return true;
        }
        const isSpStringInEntryDifferent = this.spStringKeyInEntry.some(key => itemB.entry[key] && String(itemB.entry[key]).trim().length > 0 && itemA.entry[key] !== itemB.entry[key]);
        if (isSpStringInEntryDifferent) {
            return true;
        }
        const sendersA = Array.isArray(itemA.senders) ? itemA.senders : [];
        const sendersB = Array.isArray(itemB.senders) ? itemB.senders : [];
        const sendersASet = new Set(sendersA.map(v => v.originName + v.contactItem.contactItemVal));
        const sendersBSet = new Set(sendersB.map(v => v.originName + v.contactItem.contactItemVal));
        const isSendersDifferent = util.isArrayDifferent([...sendersASet], [...sendersBSet]);
        if (isSendersDifferent) {
            return true;
        }
        const attachmentUrlsA = Array.isArray(itemA.entry.attachment) ? itemA.entry.attachment.map(v => v.fileUrl).filter(v => !!v) : [];
        const attachmentUrlsB = Array.isArray(itemB.entry.attachment) ? itemB.entry.attachment.map(v => v.fileUrl).filter(v => !!v) : [];
        const isAttachmentDifferent = !util.isArrayContains(attachmentUrlsA, attachmentUrlsB);
        if (isAttachmentDifferent) {
            return true;
        }
        const isThreadMessageIdsDifferent = util.isArrayDifferent(itemA.entry.threadMessageIds, itemB.entry.threadMessageIds);
        if (isThreadMessageIdsDifferent) {
            return true;
        }
        const isConvFidsDifferent = util.isArrayDifferent(itemA.convFids, itemB.convFids);
        if (isConvFidsDifferent) {
            return true;
        }
        const isTagsDifferent = util.isArrayDifferent(itemA.tags, itemB.tags);
        if (isTagsDifferent) {
            return true;
        }
        return false;
    }
    getAttachmentsIllegal(dtA, dtB) {
        if (!dtA || !dtB) {
            return -1;
        }
        const fileUrlMapA = dtA.reduce((total, current) => {
            if (current.fileUrl) {
                total.set(current.fileUrl, current);
            }
            return total;
        }, new Map());
        const fileUrlMapB = dtB.reduce((total, current) => {
            if (current.fileUrl) {
                total.set(current.fileUrl, current);
            }
            return total;
        }, new Map());
        for (const [keyA, valueA] of fileUrlMapA) {
            const valueB = fileUrlMapB.get(keyA);
            if (valueB) {
                const illegalNum = this.getAttachmentIllegal(valueA, valueB);
                if (illegalNum > 0) {
                    return illegalNum;
                }
            }
        }
        return -1;
    }
    getAttachmentIllegal(dtA, dtB) {
        var _a, _b, _c, _d;
        if (dtA.fileUrl !== dtB.fileUrl) {
            return -1;
        }
        if (dtA.inlined !== dtB.inlined) {
            const dtAImageIllegal = ((_a = dtA.fileMime) === null || _a === void 0 ? void 0 : _a.includes('image')) && !((_b = dtA.fileName) === null || _b === void 0 ? void 0 : _b.endsWith(`.${dtA.fileType}`));
            const dtBImageIllegal = ((_c = dtB.fileMime) === null || _c === void 0 ? void 0 : _c.includes('image')) && !((_d = dtB.fileName) === null || _d === void 0 ? void 0 : _d.endsWith(`.${dtB.fileType}`));
            if (dtAImageIllegal || dtBImageIllegal) {
                return 2;
            }
            return 1;
        }
        return -1;
    }
}
MailModelHandler.mailPrefix = 'm_';
MailModelHandler.mailInitModelPrefix = 'i_';
MailModelHandler.MAIL_ENTRY_EXPIRED_SPAN = 1000 * 60 * 24 * 7;
MailModelHandler.htmlApi = api.requireLogicalApi(apis.htmlApi);
